import StatCard from './StatCard'
import type { IndustryStat } from '../data/types'

interface StatBandProps {
    header: string;
    stats: [IndustryStat, IndustryStat, IndustryStat];
}

export function StatBand({ header, stats }: StatBandProps) {
    return (
        <section className="bg-unimo-stone pt-section-gap">
            <h2 className="mb-section-headline-gap-bottom text-2xl font-medium text-unimo-slate lg:text-4xl">
                {header}
            </h2>
            <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
                {stats.map((stat) => (
                    <StatCard key={stat.citation} {...stat} />
                ))}
            </div>
        </section>
    )
}

export default StatBand
